<template>
  <div class="article-1" prerender>
    <div class="article__info">
      <h1 class="article__title">執政是選票包袱 政策不是催票紅利</h1>
      <h2 class="article__subtitle"></h2>
      <div class="article__reporter">聯合報 記者：鄭媁、蔡晉宇、張文馨／報導</div>
    </div>

    <figure class="article__figure article__cover">
      <div class="article__figure-photo" :style="`background-image: url(${require('@/assets/articles/article-1-cover.jpg')})`"></div>
      <figcaption class="article__figure-caption">
        <span>民進黨正副總統候選人蔡英文、賴清德在高雄「合體」，宣布「大南方、大發展—南台灣發展計畫」。記者劉學聖／攝影</span>
      </figcaption>
    </figure>

    <p class="article__paragraph">執政黨每逢選舉前夕，大量拋出利多政策，在野黨苦無行政資源，只好以「政策買票」回攻；但從數據分析顯示，執政黨的得票數往往下滑，顯示執政是「包袱」，而非「紅利」。</p>
    <p class="article__paragraph">不論藍綠執政，他們所繳出的成績單，往往會帶給選票負面衝擊，不過，綠營的支持者受到影響較小，選票流失情況不如藍營劇烈，顯示對民進黨執政較為包容；相對之下，藍營支持者對國民黨執政標準較為嚴格。</p>

    <!-- chart-1 -->
    <div class="article__chart">
      <div class="article__chart-caption">藍綠執政縣市的縣市長、總統大選催票率（%）</div>
      <div class="article__chart-figure article-1__chart-figure-1">
        <SvgSymbol use="#article-1-chart-1"/>
      </div>
      <div class="article__chart-annotation"><!--
      --><span>資料來源：中選會</span><!--
      --><span>本文自行彙整</span>
      </div>
    </div>

    <p class="article__paragraph">2008年到2016年，馬英九政府執政期間，藍軍 <Dictionary word="催票率" meaning="<div>得票率 vs 催票率</div><div>得票率=得票數／投票數</div><div>催票率=得票數／總選舉人數</div>" /> 波動幅度大，在2008年創下46.6%的高動員力後，逐年開始走下坡，第二年立刻掉到35.45%，只有2012年爭取連任時，藍綠選情緊繃，催票率一度拉回到41.49%，不過，隨後每況愈下，2016年盪到25.46%最低點，顯示中央執政的包袱影響到投票意願。</p>
    <p class="article__paragraph">反觀同期的民進黨，因為是在野黨，催票曲線呈現微幅成長的趨勢，一路從2008年的38.72%開始成長，在2014年都還維持在40%左右，即便2016年下挫到37.29%，仍領先國民黨有段不小的差距。</p>
    <p class="article__paragraph">隨著政黨輪替後，執政包袱更迭，藍綠催票率出現交叉。2018年的九合一選舉，藍營由25.46%反彈到36.8%，綠營於是開始下降，從37.29%跌到32.77%。</p>
    <p class="article__paragraph">世新大學行管系教授 <Dictionary word="莊文忠" meaning="國立政治大學博士，現任世新大學行政管理系教授，台灣透明組織協會理事，以及中華組織發展協會理事。研究領域為公共政策分析、研究方法、政府績效管理、民意調查。" /> 說，如果國民黨執政縣市意謂為藍營優勢選區，當中央與地方都為同一政黨執政時，催票率若出現萎縮，可以視為受到執政包袱的影響。</p>

    <figure class="article__figure">
      <div class="article__figure-photo" :style="`background-image: url(${require('@/assets/articles/article-1-photo-1.jpg')})`"></div>
      <figcaption class="article__figure-caption">
        <span>執政黨每逢選舉前夕，大量拋出利多政策，政院正式宣布高鐵將南延屏東，立委也瞄準農業縣市選票，喊價加碼老農津貼。記者劉學聖／攝影</span>
      </figcaption>
    </figure>

    <h3 class="article__paragraph-title">綠營待己以寬 藍營對己以嚴</h3>

    <p class="article__paragraph">再進一步分析，藍軍波動起伏比綠營大，馬英九在2008年首次執政後， 2009、2010年的地方選舉，立刻跌了11.15個百分點；2012年到2016年，更重挫16.03個百分點。</p>
    <p class="article__paragraph">受國民黨執政包袱的相對激勵，民進黨從2008年以後的催票率，大約維持在四成上下，顯見綠營選民一路相挺。2014年更席捲13席縣市，為2年後的總統選舉奠定基礎，或許因為許多人認為蔡英文「篤定當選」，2016年的催票率反而下降到37.2%。</p>
    <p class="article__paragraph">蔡英文入主總統府後，風水輪流轉，綠營在2018年受中央執政拖累，催票率蒸發了4.52個百分點，但和馬英九相比，下挫幅度有限，意味著對於民進黨施政好壞與否，綠營支持者寧可選擇不離不棄。</p>
    <p class="article__paragraph">因此，執政黨一再祭出利多，不見得有利催化選情，這些政策很可能被視為理所當然；相反地，執政黨若施政稍有不當，更容易被放大檢視，影響最後投票意願。</p>

  </div>
</template>

<script>
import Dictionary from '@/components/Dictionary'

export default {
  name: 'Article1',
  components: {
    Dictionary
  },
  inject: [ 'baseUrl' ]
}
</script>

<style lang="scss">
.article-1 {

  &__chart-figure {
    &-1 {
      @include use-fixed-ratio(745, 597);
    }

    .svg-symble {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
